import PropTypes from "prop-types";
import React from "react";
import FormItem from "antd/lib/form/FormItem";
import { InputWrapper, TitleWrapper, TitleMarginTop, WrapLabel} from "../styles";
import { Form, Input } from "antd";
import { InputField } from "../../../../../CommonComponents/commonStyles";

const InputComponent = props => {
    const { getFieldDecorator } = props.form;

  return (
    <div>
      <WrapLabel>
      <FormItem
        colon={false}
        label={(props.showTitle === false) ? '':
          <TitleMarginTop>
            <TitleWrapper>{props.title}</TitleWrapper>
          </TitleMarginTop>
        }
      >
        {getFieldDecorator(props.id, {
          rules: [{ type: "string" }]
        })(
          <InputWrapper>
            <InputField
              aria-label={props.arialabel}
              disabled={props.disabled}
              onBlur={props.handleBlur}
              maxLength={props.max}
              onChange={props.handleChange}
              placeholder={props.placeholderText}
              value={props.value}
              aria-label={props.ariaLabel}
            />
          </InputWrapper>
        )}
      </FormItem>
      </WrapLabel>
    </div>
  );
};

InputComponent.propTypes = {
  disabled: PropTypes.func,
  form: PropTypes.object,
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func,
  id: PropTypes.string,
  max: PropTypes.number,
  placeholderText: PropTypes.string,
  showTitle: PropTypes.bool,
  title: PropTypes.string,
  value: PropTypes.string
};

const WrappedInputComponent = Form.create({ name: "select" })(InputComponent);

export default WrappedInputComponent;
